import React from 'react';

import withLayout from '../../hoc/with-layout';
import VersionHistoryController from './doc-version-history.controller';

const VersionHistoryScreen: React.FC = () => {
  return <VersionHistoryController />;
};
export default withLayout(VersionHistoryScreen);
